<div class="donate no-print" [class.show]="showDonationForm === true">
  <div class="teaser">
    <div class="text">
      <p [innerHTML]="textkeyPrefix + '.donate.teaser' | translate"></p>
      <p class="name" [innerHTML]="textkeyPrefix + '.donate.name' | translate"></p>
    </div>
    @if (showDonationForm === false) {
      <button [attr.aria-expanded]="showDonationForm" aria-controls="iframe" (click)="showDonationForm = true" class="button signal2 inline-arrow-right" [innerHTML]="textkeyPrefix + '.donate.button' | translate"></button>
    }
    <div class="img">
      <img src="/gfx/all/spendimonial.png" alt="">
    </div>
  </div>
  <iframe [style.display]="showDonationForm === true? 'block' : 'none'" id="iframe" src="https://spenden.twingle.de/co2online-gemeinnutzige-gmbh/co2online-fundraising-webseiten-banner/tw6103c032d04a1/widget" style="width: 100%; border: none; overflow: hidden; height: 450px; position: relative; z-index: 2;"></iframe>
</div>
